export default __webpack_public_path__ + "static/media/clock-modified.e90cf70e.png";